import { BASE_URL } from "../BaseUrl.js"; 
import axios from "axios";

axios.interceptors.request.use(function (config) {
  const token = localStorage.getItem("momo4scoohclient")
  if (token) {
    config.headers.Authorization =  `Bearer ${token}`;
  } else {
    config.headers.Authorization =  null;
  }

  const codeEntite = localStorage.getItem("entiteSchoolCode")
  if (codeEntite) {
    config.headers['ref_entity'] = `client_${codeEntite}`;
  } else {
    config.headers['ref_entity'] =  null;
  }

  return config;
});

const customHeader = {
  etablissementId: localStorage.getItem("sousEntiteId")
    ? localStorage.getItem("sousEntiteId")
    : null,
};

export const getListeAnnee = async () => {
  return await axios.get(
    BASE_URL(`annee`),
    { headers: Object.assign({}, axios.defaults.headers.common, customHeader) }
  );
};

export const rechercheGrapheNombrePaiement = async (values) => {
  return await axios.post(
    BASE_URL(`etablissement/recherchergraphenombrepaiements`),
    values,
    { headers: Object.assign({}, axios.defaults.headers.common, customHeader) }
  );
};

export const rechercheGrapheMontantPaiement = async (values) => {
  return await axios.post(
    BASE_URL(`etablissement/recherchergraphemontantpaiements`),
    values,
    { headers: Object.assign({}, axios.defaults.headers.common, customHeader) }
  );
};


